// extracted by mini-css-extract-plugin
module.exports = {"TodoDetail":"TodoDetail_TodoDetail__3mAoa"};